(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (n, dec) => n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  const count = (el) => {
    const target = parseFloat(el.dataset.leoCount);
    const dec = (el.dataset.leoCount.split('.')[1] || '').length;
    const suffix = el.dataset.leoSuffix || '';
    if (reduce) { el.textContent = fmt(target, dec) + suffix; return; }
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e, dec) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      if (el.hasAttribute('data-leo-reveal')) el.classList.add('is-in');
      if (el.hasAttribute('data-leo-count')) count(el);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
  const scan = (root) => root.querySelectorAll('[data-leo-reveal],[data-leo-count]').forEach((el) => io.observe(el));
  scan(document);
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  const loops = new IntersectionObserver((entries) => {
    entries.forEach((en) => en.target.classList.toggle('leo-paused', !en.isIntersecting));
  });
  document.querySelectorAll('.leo-section').forEach((s) => loops.observe(s));
})();
